import { useTranslation } from "@refinedev/core";
import { Label } from "components/label";
import { IAdditionalSetupData, ISimpleEventDetail } from "interfaces";
import { getFormattedDateTime } from "utills/helpers";

export const Einvoice = ({
  additionalSetupData,
}: {
  additionalSetupData: IAdditionalSetupData | null;
  eventDetailData: ISimpleEventDetail;
}) => {
  const { translate } = useTranslation();
  return (
    <div className="box-container p-4 text-sm sm:p-6">
      <div className="grid gap-x-4 gap-y-6 sm:grid-cols-8 lg:gap-x-6">
        <div className="col-span-full">
          <Label
            required
            id="additionalSetupData?.label_event_on_einvoice"
            name={translate(
              "eventSetup.additionalSetup.einvoice.labelEventOnEinvoice",
            )}
          />
          <p>{additionalSetupData?.label_event_on_einvoice ?? ""}</p>
        </div>
      </div>
    </div>
  );
};
